import VCCapitalCallPortion from "./VCCapitalCallPortion";

export default VCCapitalCallPortion;
